import { InverseHeader } from '@jouzen/ecom-components';

import LandingPageAccuracy from '@/app/components/LandingPage/LandingPageAccuracy';

import accuracyCards from './data/accuracyCards';

const BusinessAccuracy = () => {
  return (
    <InverseHeader enter>
      <section
        className="flex flex-col bg-sandstone-200 sm:py-20 md:h-[75vw] md:py-0 xxl:max-h-[1100px]"
        data-cy="business-improved"
      >
        <LandingPageAccuracy
          accuracyCards={accuracyCards}
          backgroundImage={{
            className: 'object-cover',
            fill: true,
            localizedAlt: 'business_image_friends_alt',
            srcSet: [
              {
                src: 'blue-sky/business-for-oura/business_accuracy_bg.jpeg?exp=-8',
                media: '(max-width: 767px)',
              },
              {
                src: 'blue-sky/business-for-oura/business_accuracy_bg.jpeg?exp=-8&ar=16:10&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.46&fp-z=1',
                media: '(min-width: 768px)',
              },
            ],
          }}
          description="business_improved_description"
          descriptionShadowColor="#000000"
          title="business_improved_health_revised_title"
          titleShadowColor="#143254"
        />
      </section>
    </InverseHeader>
  );
};

export default BusinessAccuracy;
